import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuthStatus, useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';
import { safeCheckIsAuth } from '#modules/user/features/auth/utils/checkIsAuth';
import { isPwaOrTwa } from '#features/notifications/utils/isPwaOrTwa';
import { useSSR } from '#hooks/useSSR';

export const Route = createFileRoute('/{-$locale}/_layout/_landing')({
  // Landing renders its own footer inside its content grid; suppress the global one
  // (inherited by all _landing/* routes). See MainLayout + router.tsx StaticDataRouteOption.
  staticData: { rendersOwnFooter: true },
  beforeLoad: async () => {
    const { isAuth, status } = await safeCheckIsAuth();

    if (status === 'ok' && isAuth) {
      throw redirect({ to: '/{-$locale}/dashboard' });
    }

    if (status === 'ok' && isPwaOrTwa()) {
      throw redirect({ to: '/{-$locale}/sign-in' });
    }
  },
  component: LayoutComponent,
});

function LayoutComponent() {
  const navigate = useNavigate();
  const isAuth = useIsAuth();
  const authStatus = useAuthStatus();
  const { isBrowser } = useSSR();

  useEffect(() => {
    if (!isBrowser || authStatus !== 'ok' || isAuth || !isPwaOrTwa()) {
      return;
    }

    navigate({ to: '/{-$locale}/sign-in', replace: true });
  }, [authStatus, isBrowser, isAuth, navigate]);

  return <Outlet />;
}
